// Owner in P4: piece 5 "marketing" (docs/FILE-OWNERSHIP.md, "The P4 pieces").
// The feature's entry file (docs/CONTRACTS.md sections 16 and 22.6): `/marketing`, one lazy chunk. The URL carries the tab, the
// funnel's grouping and its period, each a word or a number from a closed list (`search.ts`), never free text (section 5).
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Megaphone } from 'lucide-react'
import type { Feature } from '../feature.ts'
import { parseSearch } from './search.ts'

export const feature: Feature = {
  app: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/marketing',
      validateSearch: (search: Record<string, unknown>) => parseSearch(search),
      component: lazyRouteComponent(() => import('./MarketingScreen.tsx')),
    }),
  ],
  nav: [{ to: '/marketing', label: 'nav.marketing', icon: Megaphone, group: 'later', key: 'm' }],
}
